import { render, staticRenderFns } from "./option_selector.vue?vue&type=template&id=8a0f0676&scoped=true&lang=pug&"
import script from "./option_selector.vue?vue&type=script&lang=js&"
export * from "./option_selector.vue?vue&type=script&lang=js&"
import style0 from "./option_selector.vue?vue&type=style&index=0&id=8a0f0676&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0f0676",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8a0f0676', component.options)
    } else {
      api.reload('8a0f0676', component.options)
    }
    module.hot.accept("./option_selector.vue?vue&type=template&id=8a0f0676&scoped=true&lang=pug&", function () {
      api.rerender('8a0f0676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/option_selector/option_selector.vue"
export default component.exports